export class TeamStatistics {
	redCards?: number;
	yellowCards?: number;
	redYellowCards?: number;
	cornerKicks?: number;
}